"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "passignano-sul-trasimeno": {
    "16b6ba17": [{
      "hkey": "509885a9",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "oliveto": [{
      "hkey": "509885a9",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "passignano-sul-trasimeno"
    }],
    "12266c6f": [{
      "hkey": "facbce32",
      "slug": "passignano-sul-trasimeno",
      "name": "Passignano sul Trasimeno",
      "primary": true,
      "skipSearch": false
    }],
    "pischiello": [{
      "hkey": "facbce32",
      "slug": "passignano-sul-trasimeno",
      "name": "Passignano sul Trasimeno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bcd0308a": [{
      "hkey": "facbce32",
      "slug": "passignano-sul-trasimeno",
      "name": "Passignano sul Trasimeno",
      "primary": true,
      "skipSearch": false
    }],
    "trecine": [{
      "hkey": "facbce32",
      "slug": "passignano-sul-trasimeno",
      "name": "Passignano sul Trasimeno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;